import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'María G.',
  city: 'Córdoba',
  time: 'Hace 5 minutos',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Lucas F.',
  city: 'Buenos Aires',
  time: 'Hace 12 minutos',
  img: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Carla M.',
  city: 'Rosario',
  time: 'Hace 25 minutos',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Roberto A.',
  city: 'Mendoza',
  time: 'Hace 42 minutos',
  img: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Valeria S.',
  city: 'Neuquén',
  time: 'Hace 1 hora',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}];
export function FakePopup() {
  const [currentPurchase, setCurrentPurchase] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showInterval = setInterval(() => {
      setCurrentPurchase(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    }, 15000); // Show every 15 seconds
    // Initial delay
    setTimeout(() => setIsVisible(true), 3000);
    setTimeout(() => setIsVisible(false), 8000);
    return () => clearInterval(showInterval);
  }, []);
  if (!isVisible) return null;
  const purchase = purchases[currentPurchase];
  return <div className="fixed bottom-6 left-6 z-40 bg-dark-800 rounded-lg shadow-2xl p-4 flex items-center gap-4 border-l-4 border-brand-500 animate-popup max-w-sm w-[calc(100%-3rem)] md:w-auto" data-id="element-41">
      <img src={purchase.img} alt={purchase.name} className="w-12 h-12 rounded-full object-cover border border-dark-700" data-id="element-42" />
      <div data-id="element-43">
        <p className="text-sm font-bold text-gray-200" data-id="element-44">
          {purchase.name} de {purchase.city}
        </p>
        <p className="text-xs text-gray-400" data-id="element-45">Compró el Manual de Fórmulas</p>
        <div className="flex items-center gap-1 mt-1" data-id="element-46">
          <CheckCircle size={12} className="text-brand-400" data-id="element-47" />
          <span className="text-xs text-brand-300 font-medium" data-id="element-48">
            Compra verificada • {purchase.time}
          </span>
        </div>
      </div>
    </div>;
}